








































































import { defineComponent, ref, watch, computed } from '@vue/composition-api'
import { getAllSelectItemList, getAppStepsTree, getFieldTypeList, getOrderTypeList, getValueTypeList, saveAppStep, saveAppStepFields } from '@/api/admin'
import AppStep from './AppStep.vue'
import store from '@/store/index'
import { AppStepSectionDTO, FieldType, ValueType } from '@/api/types-app'
import { IOrderTypeData } from '@/api/types'
import { AppModule } from '@/store/modules/app'

export default defineComponent({
  name: 'AppStepsLayout',
  components: {
    AppStep
  },
  setup() {
    const tabVersion = ref(1)
    const loading = ref(true)
    const modalNewStep = ref(false)
    const newStepName = ref(null)
    const orderTypeAppSteps = ref(null)
    const steps = [
      {
        id: 0,
        title: 'Select Order Type',
        description: 'Some description for Order Type',
        component: ''
      },
      {
        id: 1,
        title: 'Select App Step',
        description: 'Some description for App Step',
        component: ''
      }
    ]
    const activeStep = ref<number>(0)

    const orderTypes = ref(null)
    const activeOrderType = ref<string>(null)

    const appSteps = ref(null)
    const allAppSteps = ref([])
    const activeAppStep = ref('')
    const activeAppStepObj = ref(null)

    const selectItemListCollection = ref(null)
    const valueTypeCollection = ref<Array<ValueType> | null>(null)
    const fieldTypeCollection = ref<Array<FieldType> | null>(null)
    const orderTypeCollection = ref<Array<IOrderTypeData> | null>(null)

    const getSelectItemListCollection = async() => {
      selectItemListCollection.value = (await getAllSelectItemList()).data
      AppModule.loadSelectItemListCollection(selectItemListCollection.value)
    }

    const getValueTypesCollection = async() => {
      valueTypeCollection.value = (await getValueTypeList()).data
      AppModule.loadValueTypeListCollection(valueTypeCollection.value)
    }

    const getFieldTypesCollection = async() => {
      fieldTypeCollection.value = (await getFieldTypeList()).data
      AppModule.loadFieldTypeListCollection(fieldTypeCollection.value)
    }

    const getOrderTypesCollection = async() => {
      orderTypeCollection.value = (await getOrderTypeList()).data
      AppModule.loadOrderTypeListCollection(orderTypeCollection.value)
    }

    getSelectItemListCollection()
    getValueTypesCollection()
    getFieldTypesCollection()
    getOrderTypesCollection()

    const handleDelete = (targetName, action) => {
      orderTypeAppSteps.value[activeOrderType.value].appSteps.find(appStep => appStep.displayName === targetName).delete = true
      tabVersion.value++
    }

    const getAllAppSteps = (appStep) => {
      allAppSteps.value.push(appStep)
      if (appStep.childrenPlaceholder && appStep.childrenPlaceholder.length > 0) appStep.childrenPlaceholder.forEach(child => getAllAppSteps(child))
    }

    const saveChanges = async() => {
      loading.value = true
      const data = []

      const appSteps = orderTypeAppSteps.value[activeOrderType.value].appSteps
      appSteps.forEach((step: AppStepSectionDTO) => {
        step.fields.map((f) => { f.validationRules = JSON.stringify(f.validationRules); return f })
        data.push(step)
      })

      const result = await saveAppStep(data)
      // eslint-disable-next-line no-self-assign
      if (result.data.length === 0) window.location.href = window.location.href

      result.data.forEach(async(element, index) => {
        const _result = await saveAppStepFields(element)
        console.log(index, result.data.length)
        if (index === (result.data.length - 1)) loading.value = false
      })
    }

    const addAppStep = () => {
      const orderTypeId = store.state.app.orderTypeList.find(o => o.name === activeOrderType.value).orderTypeId

      const newStep = {
        appFieldAppStepOrderTypeCombinationId: null,
        appStepId: null,
        children: null,
        description: null,
        heading: null,
        helpDescription: null,
        repeatable: false,
        fields: [],
        orderTypeId,
        new: true,
        displayName: newStepName.value
      }

      orderTypeAppSteps.value[activeOrderType.value].appSteps.push(newStep)

      appSteps.value.push(newStep)
      modalNewStep.value = false
      activeAppStep.value = newStepName.value

      newStepName.value = null
    }

    const closeModal = () => {
      modalNewStep.value = false
    }

    const request = getAppStepsTree()

    request.then((response) => {
      loading.value = false
      orderTypeAppSteps.value = response.data
      orderTypes.value = Object.keys(orderTypeAppSteps.value)
    })

    watch(activeOrderType, (_orderType) => {
      activeStep.value = _orderType !== null ? 1 : 0

      const arraySteps = orderTypeAppSteps.value[_orderType].appSteps

      appSteps.value = Object.values(arraySteps)

      activeAppStep.value = null

      if (appSteps.value.length < 1) return
      activeAppStep.value = (appSteps.value as Array<AppStepSectionDTO>)[0].displayName
      appSteps.value.forEach(_as => getAllAppSteps(_as))
    })

    watch(activeAppStep, (_activeAppStep) => {
      activeAppStepObj.value = orderTypeAppSteps.value[activeOrderType.value].appSteps.find(appStep => appStep.displayName === _activeAppStep)
    })

    return {
      orderTypeAppSteps,
      loading,
      handleDelete,
      steps,
      allAppSteps,
      activeStep,
      orderTypes,
      activeOrderType,
      appSteps,
      activeAppStep,
      activeAppStepObj,
      saveChanges,
      addAppStep,
      modalNewStep,
      closeModal,
      newStepName,
      tabVersion
    }
  }
})
